export const getAppTitle = (brand?: string): string => {
	switch (brand) {
		case 'pm':
			return 'Bonus shop';
		case 'nomad':
			return 'Bonus shop';
		case 'ngu3':
			return 'Johnny24';
		case 'com2':
			return 'VIP PASS';
		case 'rockets':
			return 'Bonus shop';
		case 'ca':
			return 'Bonus shop';
		case 'sultan':
			return 'Bonus shop';
		case 'sk2':
			return 'Bonus shop';
		default:
			return 'Bonus shop';
	}
};
